// extracted by mini-css-extract-plugin
export default {"noBackground":"mqYsFHg1ajHhexjBQf27"};